import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import { env } from "../utils/env/config";
import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";

const { node } = env;
const IS_PRODUCTION = node === "PRODUCTION";

const initialState = {};
const sagaMiddleware = createSagaMiddleware();
const middlewares: any = [sagaMiddleware];

(function () {
  middlewares.push(logger);
})();

let storeConfig;

if (IS_PRODUCTION) {
  storeConfig = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middlewares)
  );
} else {
  storeConfig = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares))
  );
}

sagaMiddleware.run(rootSaga);

const store = storeConfig;
export default store;
